import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* eslint-disable no-underscore-dangle */
import _get from 'lodash/get';
import { RECAPTCHA_SCRIPT_ID } from './RecaptchaProvider.constants';
var scriptId = RECAPTCHA_SCRIPT_ID;
var recaptchaBadge = 'grecaptcha-badge';
export function getSiteKey() {
  return process.env.GOOGLE_RECAPTCHA_SITE_KEY;
}
export function cleanGoogleRecaptcha() {
  if (typeof window === 'undefined') {
    return;
  }

  // clean badge
  var nodeBadge = document.querySelector(".".concat(recaptchaBadge));
  if (nodeBadge && nodeBadge.parentNode) {
    document.body.removeChild(nodeBadge.parentNode);
  }

  // remove old config from window
  window.___grecaptcha_cfg = undefined;

  // remove scripts
  var recaptchaScript = document.querySelector("#".concat(scriptId));
  if (recaptchaScript) {
    recaptchaScript.remove();
  }
  var gstaticRecaptchaScript = document.querySelector('script[src^="https://www.gstatic.com/recaptcha/releases"]');
  if (gstaticRecaptchaScript) {
    gstaticRecaptchaScript.remove();
  }
}
export function isRecaptchaInjected() {
  if (typeof window === 'undefined') {
    return false;
  }
  var _window = window,
    grecaptcha = _window.grecaptcha;
  if (!grecaptcha) {
    return false;
  }
  var enterprise = grecaptcha.enterprise;
  if (!enterprise) {
    return false;
  }
  var badge = document.getElementsByClassName(recaptchaBadge);
  return !!enterprise.execute && badge.length >= 1 && !!document.querySelector("#".concat(scriptId));
}
export function injectRecaptchaScript() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$onLoad = _ref.onLoad,
    onLoad = _ref$onLoad === void 0 ? function () {} : _ref$onLoad,
    _ref$appendTo = _ref.appendTo,
    appendTo = _ref$appendTo === void 0 ? 'head' : _ref$appendTo;
  if (typeof window === 'undefined') {
    return;
  }
  if (isRecaptchaInjected()) {
    // script has already been injected, just call onLoad
    onLoad();
    return;
  }
  var recaptchaSource = "https://www.recaptcha.net/recaptcha/enterprise.js?render=".concat(getSiteKey(), "&hl=en");
  var script = document.createElement('script');
  script.id = scriptId;
  script.async = true;
  script.defer = true;
  script.src = recaptchaSource;
  script.onload = onLoad;
  var elementToAppendTo = appendTo === 'head' ? document.getElementsByTagName('head')[0] : document.body;
  elementToAppendTo.appendChild(script);
}
export function getRecaptchaInstance() {
  return _get(window, 'grecaptcha.enterprise');
}
export function getRecaptchaFunction(siteKey) {
  if (!isRecaptchaInjected()) {
    return null;
  }
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(action) {
      var _window2, grecaptcha, token;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _window2 = window, grecaptcha = _window2.grecaptcha;
            _context.next = 3;
            return grecaptcha.enterprise.execute(siteKey, {
              action: action
            });
          case 3:
            token = _context.sent;
            return _context.abrupt("return", token);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}
var recaptchaLoadedProxyInstance = null;
export var RecaptchaLoadedProxy = /*#__PURE__*/function () {
  function RecaptchaLoadedProxy() {
    _classCallCheck(this, RecaptchaLoadedProxy);
    if (!recaptchaLoadedProxyInstance) {
      // this guarantees singleton object
      recaptchaLoadedProxyInstance = this;
      this.callbackFunctions = [];
    }
    return recaptchaLoadedProxyInstance;
  }
  _createClass(RecaptchaLoadedProxy, [{
    key: "registerCallback",
    value: function registerCallback(callbackFunction) {
      this.callbackFunctions.push(callbackFunction);
    }
  }, {
    key: "setLoaded",
    value: function setLoaded() {
      this.callbackFunctions.forEach(function (callback) {
        return callback();
      });
    }
  }]);
  return RecaptchaLoadedProxy;
}();